<div class="min-h-screen flex flex-col bg-slate-100">

  <!-- Navbar -->
  <header class="shrink-0 border-b border-slate-200/80 bg-white/70 backdrop-blur-md sticky top-0 z-30">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center justify-between h-16">
      @if (detail()?.companyLogoUrl) {
        <img [src]="detail()!.companyLogoUrl" alt="Logo empresa" class="h-9 w-auto max-w-[180px] object-contain" />
      } @else {
        <img src="assets/images/pento-icon.png" alt="Pento" class="h-7 w-auto" />
      }
      <div class="flex items-center gap-2 text-slate-400">
        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
            d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"></path>
        </svg>
        <span class="text-xs font-medium hidden sm:inline">Pago seguro</span>
      </div>
    </div>
  </header>

  <main class="flex-1 flex flex-col w-full min-h-0">

    <!-- Loading -->
    @if (loading()) {
    <div class="flex-1 flex flex-col max-w-7xl mx-auto w-full px-4 sm:px-6 lg:px-8 py-8 lg:py-12">
    <div class="flex-1 flex items-center justify-center min-h-[50vh]">
      <div class="text-center">
        <div class="inline-block animate-spin rounded-full h-10 w-10 border-2 border-slate-200 border-t-slate-600 mb-4"></div>
        <p class="text-slate-400 text-sm">Cargando suscripción...</p>
      </div>
    </div>
    </div>
    }

    <!-- Error -->
    @else if (error()) {
    <div class="flex-1 flex flex-col max-w-7xl mx-auto w-full px-4 sm:px-6 lg:px-8 py-8 lg:py-12">
    <div class="flex-1 flex items-center justify-center min-h-[50vh]">
      <div class="bg-white rounded-2xl shadow-lg border border-slate-200 p-10 text-center max-w-md">
        <div class="inline-flex items-center justify-center w-14 h-14 rounded-full bg-red-50 mb-4">
          <svg class="w-7 h-7 text-red-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"
              d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z">
            </path>
          </svg>
        </div>
        <p class="text-slate-700 font-medium">No se pudo cargar la suscripción</p>
        <p class="text-slate-400 text-sm mt-1">{{ errorMessage() || 'Verifica que la URL sea correcta.' }}</p>
      </div>
    </div>
    </div>
    }

    <!-- Checkout exitoso -->
    @else if (checkoutSuccess()) {
    <div class="flex-1 flex flex-col max-w-7xl mx-auto w-full px-4 sm:px-6 lg:px-8 py-8 lg:py-12">
    <div class="flex-1 flex items-center justify-center min-h-[50vh]">
      <div class="bg-white rounded-2xl shadow-lg border border-slate-200 overflow-hidden max-w-lg w-full">
        <div class="bg-emerald-600 px-6 py-6 text-center">
          <div class="inline-flex items-center justify-center w-14 h-14 rounded-full bg-white/20 mb-3">
            <svg class="w-7 h-7 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M5 13l4 4L19 7"></path>
            </svg>
          </div>
          <p class="text-white font-bold text-lg">Suscripción activada</p>
          <p class="text-emerald-100 text-sm mt-1">Tu suscripción fue registrada correctamente</p>
        </div>

        @if (subscription(); as sub) {
        <div class="px-6 py-6 space-y-4">
          <div class="pb-4 border-b border-dashed border-slate-200">
            <p class="text-[10px] uppercase tracking-widest text-slate-400 mb-1">Plan</p>
            <p class="text-slate-800 text-sm font-semibold">Plan de suscripción {{ getFrequencyLabel(sub.frequency) | lowercase }}</p>
          </div>
          <div class="pb-4 border-b border-dashed border-slate-200">
            <p class="text-[10px] uppercase tracking-widest text-slate-400 mb-1">Frecuencia</p>
            <p class="text-slate-800 text-sm">{{ getFrequencyLabel(sub.frequency) }}</p>
          </div>
          <div class="pb-4 border-b border-dashed border-slate-200">
            <p class="text-[10px] uppercase tracking-widest text-slate-400 mb-1">Suscriptor</p>
            <p class="text-slate-800 text-sm font-medium">{{ subscriberName(sub) || '—' }}</p>
            <p class="text-slate-400 text-xs mt-0.5">{{ subscriberEmail(sub) }}</p>
          </div>
          <div class="bg-slate-50 rounded-xl px-4 py-3 flex justify-between items-center">
            <span class="text-xs font-semibold text-slate-500 uppercase tracking-widest">Total</span>
            <span class="text-2xl font-extrabold font-mono text-slate-900">{{ formatAmount(sub.total) }}</span>
          </div>
        </div>
        }
      </div>
    </div>
    </div>
    }

    <!-- Suscripción ya activa -->
    @else if (isActive) {
    <div class="flex-1 flex flex-col max-w-7xl mx-auto w-full px-4 sm:px-6 lg:px-8 py-8 lg:py-12">
    <div class="flex-1 flex items-center justify-center min-h-[50vh]">
      <div class="bg-white rounded-2xl shadow-lg border border-slate-200 overflow-hidden max-w-lg w-full">
        <div class="bg-emerald-600 px-6 py-6 text-center">
          <div class="inline-flex items-center justify-center w-14 h-14 rounded-full bg-white/20 mb-3">
            <svg class="w-7 h-7 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M5 13l4 4L19 7"></path>
            </svg>
          </div>
          <p class="text-white font-bold text-lg">Suscripción activa</p>
          <p class="text-emerald-100 text-sm mt-1">Esta suscripción ya fue procesada</p>
        </div>
        @if (subscription(); as sub) {
        <div class="px-6 py-6 space-y-4">
          <div class="pb-4 border-b border-dashed border-slate-200">
            <p class="text-[10px] uppercase tracking-widest text-slate-400 mb-1">Plan</p>
            <p class="text-slate-800 text-sm font-semibold">Plan de suscripción {{ getFrequencyLabel(sub.frequency) | lowercase }}</p>
          </div>
          <div class="pb-4 border-b border-dashed border-slate-200">
            <p class="text-[10px] uppercase tracking-widest text-slate-400 mb-1">Suscriptor</p>
            <p class="text-slate-800 text-sm font-medium">{{ subscriberName(sub) || '—' }}</p>
            <p class="text-slate-400 text-xs mt-0.5">{{ subscriberEmail(sub) }}</p>
          </div>
          @if (sub.startDate) {
          <div class="pb-4 border-b border-dashed border-slate-200">
            <p class="text-[10px] uppercase tracking-widest text-slate-400 mb-1">Fecha de inicio</p>
            <p class="text-slate-800 text-sm">{{ formatDate(sub.startDate) }}</p>
          </div>
          }
          <div class="bg-slate-50 rounded-xl px-4 py-3 flex justify-between items-center">
            <span class="text-xs font-semibold text-slate-500 uppercase tracking-widest">Total {{ getFrequencyLabel(sub.frequency) | lowercase }}</span>
            <span class="text-2xl font-extrabold font-mono text-slate-900">{{ formatAmount(sub.total) }}</span>
          </div>
        </div>
        }
      </div>
    </div>
    </div>
    }

    <!-- Cancelada / Expirada -->
    @else if (isCancelled) {
    <div class="flex-1 flex flex-col max-w-7xl mx-auto w-full px-4 sm:px-6 lg:px-8 py-8 lg:py-12">
    <div class="flex-1 flex items-center justify-center min-h-[50vh]">
      <div class="bg-white rounded-2xl shadow-lg border border-slate-200 overflow-hidden max-w-lg w-full">
        <div class="bg-slate-500 px-6 py-6 text-center">
          <div class="inline-flex items-center justify-center w-14 h-14 rounded-full bg-white/20 mb-3">
            <svg class="w-7 h-7 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
            </svg>
          </div>
          <p class="text-white font-bold text-lg">Suscripción {{ getStatusLabel(subscription()?.status) | lowercase }}</p>
          <p class="text-slate-200 text-sm mt-1">Esta suscripción ya no está disponible</p>
        </div>
      </div>
    </div>
    </div>
    }

    <!-- ── PENDIENTE DE PAGO: fondos a todo el ancho / alto ── -->
    @else if (isPendingPayment) {
    @if (subscription(); as sub) {
    <div class="flex-1 flex flex-col lg:flex-row w-full min-h-0">

      <!-- Columna izquierda: tono más frío que el canvas (slate-100) + borde y sombra interior para separar del fondo -->
      <section class="relative flex-1 min-w-0 min-h-0 bg-gradient-to-b from-slate-200/90 via-slate-200/70 to-slate-200/80 border-b border-slate-300/80 lg:border-b-0 lg:border-r lg:border-slate-300/90 shadow-[inset_0_1px_0_rgba(255,255,255,0.35)] overflow-y-auto">
        <div class="relative z-10 w-full max-w-xl mx-auto px-5 py-8 sm:px-8 sm:py-10 space-y-6">

        <!-- Encabezado del plan -->
        <div class="bg-white rounded-2xl shadow-sm border border-slate-200 overflow-hidden">
          <div class="bg-gradient-to-br from-slate-800 to-slate-900 px-6 py-6">
            <h1 class="text-white text-xl font-bold leading-tight">Plan de suscripción {{ getFrequencyLabel(sub.frequency) | lowercase }}</h1>
          </div>

          <div class="px-6 py-5 space-y-5">

            <!-- Datos del cliente -->
            <div>
              <p class="text-[10px] uppercase tracking-widest text-slate-400 mb-2">Datos del cliente</p>
              <p class="text-sm font-semibold leading-snug text-slate-900">{{ subscriberName(sub) || '—' }}</p>
              <p class="mt-1 flex flex-wrap items-center gap-x-2 gap-y-0.5 text-xs text-slate-600">
                <span class="inline-flex min-w-0 items-center gap-1">
                  <svg class="h-3.5 w-3.5 shrink-0 text-slate-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                  </svg>
                  <span class="break-all">{{ subscriberEmail(sub) || '—' }}</span>
                </span>
                @if (sub.customer?.phone?.trim(); as phone) {
                <span class="hidden text-slate-300 sm:inline" aria-hidden="true">·</span>
                <span class="inline-flex items-center gap-1 text-slate-600">
                  <svg class="h-3.5 w-3.5 shrink-0 text-slate-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                  </svg>
                  {{ phone }}
                </span>
                }
              </p>
              @if (!hasSubscriberContact(sub)) {
              <p class="mt-2 text-[11px] leading-snug text-amber-800">
                Faltan nombre o correo del suscriptor; no se puede pagar. Contacta a quien te envió el enlace.
              </p>
              }
            </div>

            <!-- Frecuencia -->
            <div class="flex items-center justify-between border-t border-slate-100 pt-4">
              <span class="text-xs text-slate-500 uppercase tracking-wider font-medium">Frecuencia</span>
              <p-tag severity="info">
                <span class="text-xs">{{ getFrequencyLabel(sub.frequency) }}</span>
              </p-tag>
            </div>

            <!-- Detalle de ítems -->
            @if (planItems.length > 0) {
            <div class="border-t border-slate-100 pt-4">
              <p class="text-[10px] uppercase tracking-widest text-slate-400 mb-3">Productos / Servicios</p>
              <div class="space-y-3">
                @for (item of planItems; track item.id ?? $index) {
                <div class="flex items-start justify-between gap-3">
                  <div class="flex-1 min-w-0">
                    <p class="text-sm text-slate-700 font-medium truncate">{{ item.description ?? '—' }}</p>
                    <p class="text-xs text-slate-400 mt-0.5">Cantidad: {{ item.quantity ?? 1 }}</p>
                  </div>
                  <span class="text-sm text-slate-800 font-mono font-semibold shrink-0">{{ formatAmount(item.totalAmount) }}</span>
                </div>
                }
              </div>
            </div>
            }

            <!-- Desglose de montos -->
            <div class="border-t border-slate-100 pt-4 space-y-2">
              @if ((sub.tax ?? 0) > 0 || (sub.discount ?? 0) > 0) {
              <div class="flex justify-between text-sm text-slate-500">
                <span>Subtotal</span>
                <span class="font-mono">{{ formatAmount(sub.subtotal) }}</span>
              </div>
              }
              @if ((sub.tax ?? 0) > 0) {
              <div class="flex justify-between text-sm text-slate-500">
                <span>Impuestos</span>
                <span class="font-mono">{{ formatAmount(sub.tax) }}</span>
              </div>
              }
              @if ((sub.discount ?? 0) > 0) {
              <div class="flex justify-between text-sm text-slate-500">
                <span>Descuento</span>
                <span class="font-mono text-emerald-600">-{{ formatAmount(sub.discount) }}</span>
              </div>
              }
            </div>

            <!-- Total -->
            <div class="bg-slate-50 rounded-xl px-4 py-4 flex justify-between items-center border border-slate-100">
              <div>
                <span class="text-[10px] font-semibold text-slate-400 uppercase tracking-widest block">Total a pagar</span>
                <span class="text-xs text-slate-400">{{ getFrequencyLabel(sub.frequency) | lowercase }}</span>
              </div>
              <span class="text-3xl font-extrabold font-mono text-slate-900">{{ formatAmount(sub.total) }}</span>
            </div>
          </div>
        </div>

        <!-- Badge de seguridad (centrado respecto al mismo ancho que la tarjeta del plan) -->
        <div class="flex w-full flex-wrap items-center justify-center gap-x-3 gap-y-2 px-1 text-center">
          <div class="flex items-center gap-1.5 text-slate-500">
            <svg class="w-4 h-4 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"></path>
            </svg>
            <span class="text-[11px]">Pago cifrado SSL</span>
          </div>
          <div class="hidden sm:block w-px h-3 bg-slate-300"></div>
          <div class="flex items-center gap-1.5 text-slate-500">
            <svg class="w-3.5 h-3.5 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"></path>
            </svg>
            <span class="text-[11px]">Pago seguro</span>
          </div>
        </div>

        </div>
      </section>

      <!-- Columna derecha: imagen de fondo + formulario de pago -->
      <section class="relative flex-1 min-w-0 min-h-0 border-b lg:border-b-0 overflow-y-auto">
        <div
          class="pointer-events-none absolute inset-0 bg-cover bg-center bg-no-repeat"
          style="background-image: url('assets/images/bg/receipt-bg.jpg')"
          aria-hidden="true"></div>
        <div class="pointer-events-none absolute inset-0 bg-slate-900/45" aria-hidden="true"></div>
        <div class="relative z-10 w-full max-w-xl mx-auto px-5 py-8 sm:px-8 sm:py-10 flex flex-col gap-6">
        <div class="bg-white rounded-2xl shadow-sm border border-slate-200/90 ">

          <!-- Header del formulario -->
          <div class="px-6 lg:px-8 pt-6 lg:pt-8 pb-2">
            <h2 class="text-lg font-bold text-slate-800">Completar suscripción</h2>
            <p class="text-slate-400 text-sm mt-0.5">Completa el pago con tarjeta para activar tu suscripción</p>
          </div>

          <form [formGroup]="checkoutForm" (ngSubmit)="onCheckout()" autocomplete="off" autocapitalize="off" spellcheck="false"
            class="px-6 lg:px-8 py-5 space-y-6" data-lpignore="true" data-1p-ignore="true" data-form-type="other">

            <!-- Sección: Datos de la tarjeta -->
            <div class="p-5 rounded-xl bg-slate-50 border border-slate-200 space-y-4">
              <div>
                <label for="v2-cardholderFirstName" class="block text-xs font-medium text-slate-600 mb-1">Nombre *</label>
                <input id="v2-cardholderFirstName" type="text" formControlName="cardholderFirstName"
                  class="w-full rounded-lg border border-slate-300 px-3 py-2.5 text-sm text-slate-800 placeholder-slate-400
                  focus:outline-none focus:ring-2 focus:ring-slate-800/20 focus:border-slate-800 transition-colors bg-white"
                  placeholder="Nombre" autocomplete="off" autocorrect="off" data-lpignore="true" data-1p-ignore="true" />
                @if (checkoutForm.get('cardholderFirstName')?.touched && checkoutForm.get('cardholderFirstName')?.invalid) {
                <p class="text-red-500 text-xs mt-1">El nombre es obligatorio.</p>
                }
              </div>
              <div>
                <label for="v2-cardholderMiddleName" class="block text-xs font-medium text-slate-600 mb-1">Apellido paterno *</label>
                <input id="v2-cardholderMiddleName" type="text" formControlName="cardholderMiddleName"
                  class="w-full rounded-lg border border-slate-300 px-3 py-2.5 text-sm text-slate-800 placeholder-slate-400
                  focus:outline-none focus:ring-2 focus:ring-slate-800/20 focus:border-slate-800 transition-colors bg-white"
                  placeholder="Apellido paterno" autocomplete="off" autocorrect="off" data-lpignore="true" data-1p-ignore="true" />
                @if (checkoutForm.get('cardholderMiddleName')?.touched && checkoutForm.get('cardholderMiddleName')?.invalid) {
                <p class="text-red-500 text-xs mt-1">El apellido paterno es obligatorio.</p>
                }
              </div>
              <div>
                <label for="v2-cardholderLastName" class="block text-xs font-medium text-slate-600 mb-1">Apellido materno</label>
                <input id="v2-cardholderLastName" type="text" formControlName="cardholderLastName"
                  class="w-full rounded-lg border border-slate-300 px-3 py-2.5 text-sm text-slate-800 placeholder-slate-400
                  focus:outline-none focus:ring-2 focus:ring-slate-800/20 focus:border-slate-800 transition-colors bg-white"
                  placeholder="Apellido materno" autocomplete="off" autocorrect="off" data-lpignore="true" data-1p-ignore="true" />
              </div>

              <div>
                <label for="v2-cardNumber" class="block text-xs font-medium text-slate-600 mb-1">Número de tarjeta *</label>
                <div class="relative">
                  <input id="v2-cardNumber" type="text" formControlName="cardNumber"
                    class="w-full rounded-lg border border-slate-300 px-3 py-2.5 pr-10 text-sm text-slate-800 placeholder-slate-400 font-mono tracking-wider
                    focus:outline-none focus:ring-2 focus:ring-slate-800/20 focus:border-slate-800 transition-colors bg-white"
                    placeholder="1234 5678 9012 3456" maxlength="19" autocomplete="off" inputmode="numeric" data-lpignore="true" data-1p-ignore="true" />
                  <div class="absolute right-3 top-1/2 -translate-y-1/2 text-slate-400">
                    <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"
                        d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z"></path>
                    </svg>
                  </div>
                </div>
                @if (checkoutForm.get('cardNumber')?.touched && checkoutForm.get('cardNumber')?.invalid) {
                <p class="text-red-500 text-xs mt-1">Ingresa un número de tarjeta válido (16 dígitos).</p>
                }
              </div>

              <div>
                <label for="v2-phone" class="block text-xs font-medium text-slate-600 mb-1">Teléfono *</label>
                <input id="v2-phone" type="tel" formControlName="phone"
                  class="w-full rounded-lg border border-slate-300 px-3 py-2.5 text-sm text-slate-800 placeholder-slate-400
                  focus:outline-none focus:ring-2 focus:ring-slate-800/20 focus:border-slate-800 transition-colors bg-white"
                  placeholder="5512345678" maxlength="10" autocomplete="off" inputmode="numeric"
                  pattern="[0-9]*" (keydown)="onPhoneKeydown($event)" (input)="onPhoneInput()"
                  data-lpignore="true" data-1p-ignore="true" />
                @if (checkoutForm.get('phone')?.touched && checkoutForm.get('phone')?.invalid) {
                <p class="text-red-500 text-xs mt-1">Ingresa un teléfono de 10 dígitos.</p>
                }
              </div>

              <div class="grid grid-cols-2 gap-4">
                <div>
                  <label for="v2-expirationDate" class="block text-xs font-medium text-slate-600 mb-1">Expiración *</label>
                  <input id="v2-expirationDate" type="text" formControlName="expirationDate"
                    pInputMask="99/99"
                    (keydown)="onExpirationKeydown($event)"
                    (input)="onExpirationInput()"
                    class="w-full rounded-lg border border-slate-300 px-3 py-2.5 text-sm text-slate-800 placeholder-slate-400 font-mono
                    focus:outline-none focus:ring-2 focus:ring-slate-800/20 focus:border-slate-800 transition-colors bg-white"
                    placeholder="MM/YY" maxlength="5" autocomplete="off" inputmode="numeric" data-lpignore="true" data-1p-ignore="true" />
                  @if (checkoutForm.get('expirationDate')?.touched && checkoutForm.get('expirationDate')?.invalid) {
                  <p class="text-red-500 text-xs mt-1">Mes entre 01 y 12, formato MM/YY.</p>
                  }
                </div>
                <div>
                  <label for="v2-cvv" class="block text-xs font-medium text-slate-600 mb-1">CVV *</label>
                  <input id="v2-cvv" type="text" formControlName="cvv"
                    class="w-full rounded-lg border border-slate-300 px-3 py-2.5 text-sm text-slate-800 placeholder-slate-400 font-mono
                    focus:outline-none focus:ring-2 focus:ring-slate-800/20 focus:border-slate-800 transition-colors bg-white [font-variant-numeric:tabular-nums] [-webkit-text-security:disc]"
                    placeholder="•••" maxlength="4" autocomplete="off" inputmode="numeric" autocorrect="off" spellcheck="false" data-lpignore="true" data-1p-ignore="true" />
                  @if (checkoutForm.get('cvv')?.touched && checkoutForm.get('cvv')?.invalid) {
                  <p class="text-red-500 text-xs mt-1">3 o 4 dígitos.</p>
                  }
                </div>
              </div>
            </div>

            <!-- Error -->
            @if (errorMessage()) {
            <div class="bg-red-50 border border-red-200 rounded-lg px-4 py-3 flex items-start gap-2">
              <svg class="w-4 h-4 text-red-400 shrink-0 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
              </svg>
              <p class="text-red-700 text-sm">{{ errorMessage() }}</p>
            </div>
            }

            <!-- Botón de pago -->
            <button type="submit"
              [disabled]="checkoutLoading() || !isCheckoutFormValid() || !hasSubscriberContact(sub)"
              [class.opacity-80]="checkoutLoading()"
              class="flex items-center justify-center gap-2 w-full py-3.5 px-4 rounded-xl bg-slate-800 hover:bg-slate-700 active:bg-slate-900
              text-white text-sm font-bold transition-colors shadow-md disabled:opacity-60 disabled:cursor-not-allowed">
              @if (checkoutLoading()) {
                <svg class="animate-spin -ml-1 mr-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                  <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                  <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
                Procesando pago...
              } @else {
              <svg class="w-4 h-4 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"></path>
              </svg>
              Suscribirse y pagar {{ formatAmount(sub.total) }}
              }
            </button>

            <p class="text-[10px] text-slate-400 text-center leading-relaxed">
              Al hacer clic en "Suscribirse y pagar" aceptas los términos y condiciones del servicio.
              Tu tarjeta será procesada de forma segura.
            </p>
          </form>
        </div>

        <!-- Resumen total en mobile (visible solo en mobile debajo del form) -->
        <div class="lg:hidden bg-white rounded-xl px-4 py-3 flex justify-between items-center border border-slate-200 shadow-sm">
          <span class="text-xs font-semibold text-slate-500 uppercase tracking-widest">Total</span>
          <span class="text-2xl font-extrabold font-mono text-slate-900">{{ formatAmount(sub.total) }}</span>
        </div>

        </div>
      </section>

    </div>
    }
    }

  </main>

  <!-- Footer -->
  <footer class="mt-auto shrink-0 border-t border-slate-200/80 bg-white/90">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-5 flex flex-col sm:flex-row items-center justify-between gap-2">
      <div class="flex items-center gap-1.5 text-slate-400">
        <svg class="w-3.5 h-3.5 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
            d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"></path>
        </svg>
        <span class="text-[11px]">Pago seguro con cifrado SSL</span>
      </div>
      <p class="text-slate-300 text-[10px]">&copy; 2026 Pento &mdash; Todos los derechos reservados</p>
    </div>
  </footer>

</div>

